import { render, staticRenderFns } from "./InsuredImportItem.vue?vue&type=template&id=790eb5ac&scoped=true&"
import script from "./InsuredImportItem.vue?vue&type=script&lang=js&"
export * from "./InsuredImportItem.vue?vue&type=script&lang=js&"
import style0 from "./InsuredImportItem.vue?vue&type=style&index=0&id=790eb5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790eb5ac",
  null
  
)

export default component.exports